'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactisLoader = require('reactis-loader');

var _ActionButton = require('./ActionButton');

var _ActionButton2 = _interopRequireDefault(_ActionButton);

var _components = {
	_$SaveButton: {
		displayName: 'SaveButton'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var SaveButton = (function (_ActionButton) {
	_inherits(SaveButton, _ActionButton);

	function SaveButton() {
		_classCallCheck(this, _SaveButton);

		_ActionButton.apply(this, arguments);
	}

	SaveButton.prototype.render = function render() {
		var _this = this;

		return _react2['default'].createElement(_reactisLoader.LoadingButton, {
			loading: this.props.loading,
			disabled: this.props.disabled,
			title: 'Uložit',
			onClick: function () {
				return _this.handleClick();
			}
		});
	};

	var _SaveButton = SaveButton;
	SaveButton = _wrapComponent('_$SaveButton')(SaveButton) || SaveButton;
	return SaveButton;
})(_ActionButton2['default']);

exports['default'] = SaveButton;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SaveButton.js
 ** module id = 501
 ** module chunks = 2
 **/